import { MatPaginatorIntl } from "@angular/material/paginator";
import { Subject } from "rxjs";



export class CustomPaginatiorIntl implements MatPaginatorIntl {
    changes = new Subject<void>();
    itemsPerPageLabel = "Datos por página";
    nextPageLabel = 'Página siguiente';
    previousPageLabel= 'Página anterior';
    firstPageLabel= 'Primera página';
    lastPageLabel= 'Última página';
    getRangeLabel(page:number, pageSize:number, length:number):string{
        if (length === 0) {
            return `Página 1 de 1`;
          }
          const amountPages = Math.ceil(length / pageSize);
          return `Páginas ${page + 1} - ${amountPages} de ${length}`;

    };
}
